import { Navigate } from 'react-router-dom';

import { NBA_ONBOARDING, NBA_PLAY } from '@sorare/core/src/constants/routes';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { Lifecycle } from '@sorare/core/src/hooks/useLifecycle';

import { Landing } from 'components/landing';
import { useCurrentUserContext as currentNBAUserContext } from 'contexts/currentNBAUser';

const Home = () => {
  const { currentUser } = useCurrentUserContext();
  const { currentNBAUser, needsOnboarding, fetching } = currentNBAUserContext();

  if (fetching) {
    return null;
  }
  if (!currentUser || !currentNBAUser) {
    return <Landing />;
  }

  const navigateToOnboarding =
    currentNBAUser &&
    needsOnboarding &&
    !(currentUser.userSettings.lifecycle as Lifecycle)?.sawNbaOnboarding;

  if (navigateToOnboarding) {
    return <Navigate to={NBA_ONBOARDING} replace />;
  }

  if (currentNBAUser) {
    return <Navigate to={NBA_PLAY} replace />;
  }

  return null;
};

export default Home;
